import { ExperienceCardAction } from 'utils/searchBar';
import { SearchMode, SearchQueryStringParams } from 'components/search/utils';
import { useQueryStringParams } from 'hooks/useQueryStringParams';

export function useExperienceCardAction(mode?: SearchMode): ExperienceCardAction {
  const queryStringParams = useQueryStringParams<SearchQueryStringParams>();
  let experienceCardAction: ExperienceCardAction = 'TIME_PILL';

  if (mode?.stateType === 'city' && queryStringParams.dateEnd) {
    experienceCardAction = 'BOOK_NOW';
  }

  if (mode?.stateType === 'togo') {
    experienceCardAction = 'BOOK_NOW';
  }

  return experienceCardAction;
}
